import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { TransactionManagementScreen } from "@/screens/dashboard/TransactionManagementScreen";
import { TransactionType } from "@/types/api/index.type";

const transactionSearchSchema = z.object({
  tab: z.enum(["approved", "waiting", "rejected", "deleted"]).optional().catch("approved"),
  page: z.number().catch(1),
  pageSize: z.number().catch(10),
  search: z.string().catch(""),
  type: z
    .enum([
      TransactionType.IncomeOutcomeType.INCOME,
      TransactionType.IncomeOutcomeType.EXPENSE,
    ])
    .optional()
    .catch(undefined),
  walletId: z.string().optional().catch(undefined),
  programId: z.string().optional().catch(undefined),
  source: z.string().optional().catch(undefined),
  createdById: z.string().optional().catch(undefined),
  sortBy: z.string().catch("createdAt"),
  sortOrder: z.enum(["asc", "desc"]).catch("desc"),
  startDate: z.string().optional().catch(undefined),
  endDate: z.string().optional().catch(undefined),
  // Transaction request filters
  status: z
    .enum(["PENDING", "APPROVED", "REJECTED", "CANCELED"])
    .optional()
    .catch(undefined),
  action: z
    .enum(["CREATE", "UPDATE", "DELETE"])
    .optional()
    .catch(undefined),
  mine: z.boolean().optional().catch(undefined),
  forApproval: z.boolean().optional().catch(undefined),
});

const loaderDeps = (opts: { search: Record<string, unknown> }) => ({
  tab: opts.search.tab ?? "approved",
  page: opts.search.page ?? 1,
  pageSize: opts.search.pageSize ?? 10,
  search: opts.search.search ?? "",
  type: opts.search.type,
  walletId: opts.search.walletId,
  programId: opts.search.programId,
  source: opts.search.source,
  createdById: opts.search.createdById,
  sortBy: opts.search.sortBy ?? "createdAt",
  sortOrder: opts.search.sortOrder ?? "desc",
  startDate: opts.search.startDate,
  endDate: opts.search.endDate,
  status: opts.search.status,
  action: opts.search.action,
  mine: opts.search.mine,
  forApproval: opts.search.forApproval,
});

export const Route = createFileRoute("/dashboard/transactions/")({
  component: TransactionManagementScreen,
  validateSearch: transactionSearchSchema,
  loaderDeps,
  loader: async () => {
    return {
      crumb: "Manajemen Transaksi",
    };
  },
});
